<template>
  <div class="goodsListDetail">
    <div class="parkAdd ">
    	<div class="contentWrap"   element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">
    		<!-- 第一块 -->
    		<div class="panelBlock">
    			<div class="panelTitle"> <i class="red">*</i> <span>商品列表图片:</span> <span style="font-size: 10px;">{{multiImgInfoArr_string}}</span> </div>

          <div class="panelContent">
            <!-- :on-remove="handleRemove" -->
            <el-upload
              class="upload-item"
             :name="'files'"
             :data="uploadData"
             :action="api.baseUrl+'/file/uploadfilebatch'"
             :before-remove="beforeRemove"
             list-type="picture-card"
             :file-list="fileList"
             >
              <!-- <div class="mytriggerDiv" slot="trigger"><i class="el-icon-plus avatar-uploader-icon"></i></div> -->
              <!-- <i slot="default" class="el-icon-plus"></i> -->
              <div slot="file" slot-scope="{file}" class="slotArea">
                <img  v-if="file.url.search('blob')>-1" class="el-upload-list__item-thumbnail"  :src="file.url" alt=""              >
                <img  v-if="file.url.search('blob')==-1" class="el-upload-list__item-thumbnail"  :src="IMG_PREV+file.url" alt=""              >
                <span class="set-main" v-if="file.isMain">
                  <span>√推荐图</span>
                </span>
                <div class="imgDesBox">
                  <div class="inputOneLine">
                    <span class="textName">商品名称：</span> <span>{{file.itemName}}</span>
                  </div>
                  <div class="inputOneLine">
                    <span  class="textName">款号：</span> <span>{{file.itemStyleNumber}}</span>
                  </div>
                  <div class="inputOneLine">
                    <span  class="textName">销售价：</span> <span>{{file.itemPrice}}</span>
                  </div>
                </div>
              </div>
            </el-upload>
            <!-- <el-dialog :visible.sync="dialogVisible">  <img width="100%" :src="dialogImageUrl" alt="">    </el-dialog> -->

    			</div>
    		</div>
        <!-- 第三块 -->
        <div class="panelBlock">
        	<div class="panelTitle"><span>其他信息</span></div>
        	<div class="panelContent">
            <div class="oneLine">
              <div class="label">商品标签：</div>
              <div class="rightInput">
                <!-- <textarea name="" id="" cols="60" rows="5" v-model="storeStyleTag" placeholder="请输入园区简介"></textarea> -->
                <div class="storeTagItem" v-for="(list,index) in list_tag_store" v-if="storeTag==list.tag_id" :class="{active:storeTag==list.tag_id}" :key="index" >
                  <img :src="IMG_PREV+list.tag_icon" alt="">
                  <div class="text">{{list.tag_name}}</div>
                </div>
              </div>
            </div>
            <div class="oneLine">
              <div class="label">商品备注：</div>
              <div class="rightInput">
                {{productRemark}}
              </div>
            </div>
        	</div>
        </div>

        <!-- button -->
    	</div>
    </div>
  </div>

</template>

<script>
	import {json,wordData,utils} from '@/common/common.js'
	import { ajaxPost,api } from '@/common/request.js'
  import AMap from 'AMap'
  // import {      ajaxApp} from '@/common/request_app.js'
	export default {
		name: 'adminIndex',
		data() {
			return {
        imageType: '11501',//11101  园区头部图(即多图展示)  11201 园区方形小图（单张小头像）   11301 商家店面图  11401 品牌图11501 商品图
        uploadData:{
          imageType: '11501',
          imageUserId: ''
        },
        // multiImgInfoArr:[],//存储图片名字和其后台返回的id
        multiImgInfoArr_string:'',//存储图片名字和其后台返回的id

        fileList: [],  // 图片数据列表 - 组件所需格式
        goodsImgArr: [], // 图片数据列表 - 后台对接格式

        productRemark:'',
        storeId:'',
        list_tag_store:[],
        storeTag:'',


			}
		},
		computed: {
			IMG_PREV(){
				return api.imgPrev
			},
      api(){
        return api
      },
      adminId() {
          return utils.getAdminId()
      },
    },
    watch: {
      adminId: {
        handler: function(val) {
          this.uploadData.imageUserId = val;
        },
        immediate: true
      }
    },
		components: {
		},
		methods: {
      // 选择主图
      handleSelectMain(file, fileList) {
        // console.log(file);
        // this.fileList.forEach(item => {
        //   if (file.uid == item.uid) {
        //     item.isMain = true
        //   } else {
        //     item.isMain = false
        //   }
        // })
      },
      beforeRemove(){
        console.log(1231231)
        return false
      },
      // 获取详情数据
      getDetailData() {
        let _this = this
        let args = {
          "storeId": _this.storeId,
          "userId": ""
        }
        ajaxPost('/store/getStoreInfo', args).then(function(res) {
          console.log(res);
          if (res.errorCode == 200) {
            let productImg = res.data.productImg ? JSON.parse(res.data.productImg) : [];
            console.log(productImg);
            _this.fileList = productImg.map(item => {
              return {
                name: item.imgId,
                url: item.imageFiles.split(',')[0],
                wwId: item,
                wwType: 11501,
                isMain: item.isMain == 1 ? true : false,
                itemName: item.itemName||'',
                itemPrice:  item.itemPrice||'',
                itemStyleNumber:  item.itemStyleNumber||'',
              }
            })
            _this.storeTag = res.data.storeStyleTag;
            _this.productRemark = res.data.productRemark;
          }
        }, function(res) {

        })
      },
      choseTag(list){
        this.storeTag=list.tag_id
      },
      submitClick(){
        let _this=this
        // if(!_this.multiImgInfoArr_string){
        if (this.fileList.length == 0) {
          _this.$message({
               message: "商品图至少传一张",
               type: 'error',
          });
          return false
        }
        // if (this.fileList.length > 10) {
        //   _this.$message({
        //        message: "商品图最多上传 10 张",
        //        type: 'error',
        //   });
        //   return false
        // }
        if (this.fileList.filter(item => item.isMain).length == 0 || this.fileList.filter(item => item.isMain).length > 3) {
          _this.$message({
               message: "推荐图最少1张，最多3张",
               type: 'error',
          });
          return false
        }
        // if (this.fileList.filter(item => item.isMain).length != 1 ) {
        //   _this.$message({
        //        message: "请设置一张图片为主图",
        //        type: 'error',
        //   });
        //   return false
        // }
        _this.goodsImgArr  = this.fileList.map(item => {
          return {
            ...item.wwId,
            isMain: item.isMain ? 1 : 0,
            itemName: item.itemName||'',
            itemPrice:  item.itemPrice||'',
            itemStyleNumber:  item.itemStyleNumber||'',
          }
        });
        console.log(_this.goodsImgArr)
        let arg={
          storeId:_this.storeId,
          adminId:_this.adminId,
          productImg: JSON.stringify(this.goodsImgArr), //  _this.turnImgIdToJson(_this.multiImgInfoArr_string),
          storeStyleTag:_this.storeTag,
          productRemark:_this.productRemark,

        }
        console.log(arg)
        ajaxPost('/store/addProductInfo', arg).then(function(res) {
          if(res.errorCode==200){
            _this.$message({
               message: "新增成功",
               type: 'success',
            });
            _this.$router.back()
          }else{
            _this.$message({
               message: res.errorMsg,
               type: 'error',
            });
          }
        }, function(res) {})
      },
      turnImgIdToJson(str){
        console.log(str)
        let result=''
        if(str){
          let arr=str.split(",")
          let newArr=arr.map(function(item,index){
            return JSON.parse(item)
          })
          console.log(newArr)
          result=JSON.stringify(newArr)
        }else{
          result=""
        }
        console.log(result)
        return result

      },
			back(){
				this.$router.back()
			},
      getParam() {
        this.storeId = this.$route.params.id
      },
      exceedHandle(){
        alert("只允许上传一张")
      },
      handleRemove(file, fileList) {
        console.log(file, fileList)
        if(file.wwType=='11501'){
          console.log("删除的是多图")

          this.fileList = fileList.filter(item => item.uid != file.uid );
          // this.multiImgInfoArr_string=this.computeImgIdArrToString(fileList)
        }
      },
      handleDownload(file) {
        console.log(file);
      },
      addImgClick(type){//点击不同的图片上传按钮，设置imagetype及图片data
        console.log('点击上传按钮---'+type)
        if(type=='multi'){
           this.imageType=11501
           this.uploadData = {
               imageType: this.imageType,
               imageUserId: this.adminId,
           }
           // console.log(this.uploadData)
        }
      },
      computeImgIdArrToString(fileList){
        let idArr=[]
        for(var i=0;i<fileList.length;i++){
          let oneItem=fileList[i]
          let str=oneItem.wwId
          let arr=str.split(",")
          for(var j=0;j<arr.length;j++){
            let smallItem=arr[j]
            idArr.push(smallItem)
          }

        }
        return idArr.join(",")
      },
      addImgSuccessHandle(res, file,fileList){//自动上传成功以后的操作
        console.log(res);
        console.log("上传图片成功---")
        console.log(this.imageType)
        console.log(file, fileList);

        if(res.errorCode==200){
          file.wwId=res.data
          file.wwType=this.imageType

          this.fileList = fileList;
          if(this.imageType=='11501'){
            // this.multiImgInfoArr_string=this.computeImgIdArrToString(fileList)
            // this.goodsImgArr.push(res.data);
            // console.log(this.goodsImgArr);
          }
        }

      },
      getTagItemList(){
        let _this=this
        console.log(arg)
        let arg={tagType:"item"}
        ajaxPost('/tag/tagList', arg).then(function(res) {
          console.log(res)
          if(res.errorCode==200){
            _this.list_tag_store=res.data

          }else{

          }
        }, function(res) {})
      },

		},
		mounted() {
			let _this = this
      this.getParam()
      this.getTagItemList()
      this.getDetailData();
		},
		destroyed(){
		}
	}

</script>

<style  lang="scss">
	* {
		// outline: 1px solid blue;
	}
  .goodsListDetail{
    .storeTagItem:hover,.storeTagItem.active{background: #ddfeff;border-color:blue; box-shadow: 0 0 3px #ddd;}
     .storeTagItem{border:1px solid #ddd;padding:5px;display: inline-block;margin-right: 5px;cursor:pointer; border-radius: 6px;
       img{width: 50px;height: 50px;} text-align: center;
     }
     #mapContainer {width:800px; height: 480px;}
     .parkAdd{
       input{height: 28px;}
       textarea{border:1px solid #ddd;border-radius: 6px;}
       .tagBox{margin-right: 5px;border:1px solid royalblue;background-color: royalblue; color:#fff; border-radius: 6px; padding:2px 5px;}
       .deleteIcon{color:blue;cursor: pointer;position: relative;top:-10px;left:-10px;}
       textarea{vertical-align: top;}
       background: #fff;; padding:20px;padding-bottom:100px;
       .panelBlock{
         .panelTitle{font-weight: bold;padding:10px 0;}
         .panelContent{
           .oneLine{
             padding:10px;
             .label{display: inline-block;padding:0 20px;}
             .rightInput{display: inline-block;}
           }
         }
       }
       .btnBox{text-align: center;}
     }

    .set-main {
       position: absolute;
       left: -1px;
       top: -1px;
       color:blue;
       background: rgba(255,255,255,0.6);padding:5px;font-size:12px ;
       text-align: left;
       border-radius: 4px;
       z-index: 2;
    }
    // .slotArea{border:1px solid blue;}
    .imgDesBox{
      position: absolute;
      left: 5px;
      width: 200px;
      bottom:4px;
      background: #fff;
      text-align: center;
      // box-shadow: 0 0 1px 1px rgba(0,0,0,.2);
      border-radius: 4px;
      z-index: 5;
    }
    .imgDesBox{
      .inputOneLine{
        margin-top:3px;text-align: left;
        .textName{line-height: 1;display: inline-block;width: 70px;text-align: left;}
        input{width: 100px;}
      }

    }
    .el-upload-list--picture-card .el-upload-list__item-thumbnail{height: 150px !important;width: auto;}
    .el-upload-list__item-thumbnail{height: 150px;width: auto;}
    .el-upload-list--picture-card .el-upload-list__item{height: 250px;width: 250px;box-shadow: 0 0 3px #eee;}
    .el-upload-list__item-actions{height: 150px;}
    .el-upload--picture-card{display: none;}
  }

</style>



// WEBPACK FOOTER //
// src/pages/goods/detail.vue